// extracted by mini-css-extract-plugin
export default {"products":"Mx-z","card":"Nx-z","oosMessaging":"Ox-z"};